
import React from 'react';
import { TableRow, TableCell } from '@/components/ui/table';

interface EmptyRowProps {
  colSpan: number;
  message?: string;
}

const EmptyRow: React.FC<EmptyRowProps> = ({ 
  colSpan, 
  message = "Không tìm thấy kết quả phù hợp" 
}) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="text-center py-4">
        {message}
      </TableCell>
    </TableRow>
  );
};

export default EmptyRow;
